@if (railMenu; as entries) {
  <app-rail-menu
    [entries]="entries"
    [submenus]="{ 'new-item': newContactForm, 'new-container': newGroupForm }"
    (selected)="runRailEntry($event)"
  />
  <ng-template #newContactForm>
    <app-contact-quick-form class="quick-form" [contact]="railNewContact" [tenantItems]="railTenantItems" [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true" (close)="handleClose()" (more)="handleQuickDetails($event)" />
  </ng-template>
  <ng-template #newGroupForm>
    <app-group-quick-form class="quick-form" [group]="railNewGroup" [tenantItems]="railTenantItems" [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true" (close)="handleClose()" (more)="handleQuickDetails($event)" />
  </ng-template>
} @else {
@if (sidebarFilterKey === 'following') {
  <app-context-menu-item title="Clear my subscriptions" [close]="true" (execute)="clearMySubscriptions()" />
}
@if ((isTeamRail && sidebarFilterKey === 'all_groups') || !(['all_groups', 'deleted', 'archived'] | includesBy: sidebarFilterKey)) {
  <app-context-menu-item
    title="Add new contact"
    >
    <app-contact-quick-form
      class="quick-form"
      [contact]="stitchItem"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
      (more)="handleQuickDetails($event)" />
    </app-context-menu-item>
  }

  @if ((isTeamRail && sidebarFilterKey === 'all_contacts') || !(['all_contacts', 'deleted', 'archived'] | includesBy: sidebarFilterKey)) {
    <app-context-menu-item
      title="Add new group"
      >
      <app-group-quick-form
        class="quick-form"
        [group]="containerStitchItem"
        [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
        (close)="handleClose()"
        (more)="handleQuickDetails($event)"
        />
      </app-context-menu-item>
    }

    @if (!(['deleted', 'archived'] | includesBy: sidebarFilterKey) && (endsWithSettings || (['flagged', 'followed', 'snoozed'] | includesBy: sidebarFilterKey))) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'flagged') {
      <app-context-menu-item
        title="Unflag all"
        [close]="true"
        (execute)="unFlagAll()"
        />
    }

    @if (sidebarFilterKey === 'followed') {
      <app-context-menu-item
        [title]="followUpWording.removeAllFollowUps()"
        [close]="true"
        (execute)="unFollowAll()"
        />
    }

    @if (sidebarFilterKey === 'snoozed') {
      <app-context-menu-item
        title="Unsnooze all"
        [close]="true"
        (execute)="unSnoozeAll()"
        />
    }

    @if (endsWithSettings && (['flagged', 'followed', 'snoozed'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'archived') {
      <app-context-menu-item
        title="Delete all"
        [close]="true"
        (execute)="deleteAll()"
        />
    }

    @if (sidebarFilterKey === 'deleted') {
      <app-context-menu-item
        title="Empty trash"
        [disabled]="!(tenantId | appCanPurgeTeamItem)"
        [note]="PURGE_REFUSED_REASON"
        [matTooltip]="(tenantId | appCanPurgeTeamItem) ? '' : PURGE_REFUSED_REASON"
        [close]="true"
        (execute)="emptyTrash()"
        />
    }

    @if (rail) {
      <app-context-menu-item title="View settings…" [close]="true" (execute)="openRowViewSettings()" />
    } @else if (endsWithSettings) {
      <!-- Pavel 2026-11-04: no Contacts "Settings" on a personal login's rail (its only page was the old one). -->
      <app-context-menu-item
        title="Settings"
        [close]="true"
        (execute)="openSettings()"
        />
    }
}
